export default {
  moneySymbol: '€',
  deleteThisLine: 'Verwijder deze regel',
  copyThisLine: 'Kopieer deze regel',
  form: {
    lightFilter: {
      more: 'Meer filters',
      clear: 'Wissen',
      confirm: 'Bevestigen',
      itemUnit: 'item'
    }
  },
  tableForm: {
    search: 'Zoeken',
    reset: 'Resetten',
    submit: 'Indienen',
    collapsed: 'Uitvouwen',
    expand: 'Inklappen',
    inputPlaceholder: 'Voer in',
    selectPlaceholder: 'Selecteer'
  },
  alert: {
    clear: 'Selectie annuleren',
    selected: 'Geselecteerd',
    item: 'item'
  },
  pagination: {
    total: {
      range: 'Van',
      total: 'items/totaal',
      item: 'items'
    }
  },
  tableToolBar: {
    leftPin: 'Vastzetten aan begin',
    rightPin: 'Vastzetten aan einde',
    noPin: 'Niet vastzetten',
    leftFixedTitle: 'Vastzetten aan de linkerkant',
    rightFixedTitle: 'Vastzetten aan de rechterkant',
    noFixedTitle: 'Niet vastzetten',
    reset: 'Resetten',
    columnDisplay: 'Kolomweergave',
    columnSetting: 'Kolominstellingen',
    fullScreen: 'Volledig scherm',
    exitFullScreen: 'Verlaat volledig scherm',
    reload: 'Vernieuwen',
    density: 'Dichtheid',
    densityDefault: 'Normaal',
    densityLarger: 'Ruim',
    densityMiddle: 'Gemiddeld',
    densitySmall: 'Compact'
  },
  stepsForm: {
    next: 'Volgende stap',
    prev: 'Vorige stap',
    submit: 'Indienen'
  },
  loginForm: {
    submitText: 'Inloggen'
  },
  editableTable: {
    onlyOneLineEditor: 'Slechts één regel tegelijk bewerken',
    action: {
      save: 'Opslaan',
      cancel: 'Annuleren',
      delete: 'Verwijderen',
      add: 'Een regel toevoegen'
    }
  },
  switch: {
    open: 'Openen',
    close: 'Sluiten'
  }
};